export const PATH_INTERVENTION = "/intervention";
export const KEY_INTERVENTION = "intervention";
export const TITLE_INTERVENTION = "Intervention";

export const PATH_INTERVENTION_CAMPAGNE = `${PATH_INTERVENTION}/campagne`;
export const KEY_INTERVENTION_CAMPAGNE = `${KEY_INTERVENTION}/campagne`;
export const TITLE_INTERVENTION_CAMPAGNE = "Liste des campagnes";

export const PATH_INTERVENTION_INTERVENTION = `${PATH_INTERVENTION}/intervention`;
export const KEY_INTERVENTION_INTERVENTION = `${KEY_INTERVENTION}/intervention`;
export const TITLE_INTERVENTION_INTERVENTION = "Liste des interventions";

export const PATH_INTERVENTION_LOT_INTERVENTION = `${PATH_INTERVENTION}/lot-intervention`;
export const KEY_INTERVENTION_LOT_INTERVENTION = `${KEY_INTERVENTION}/lot-intervention`;
export const TITLE_INTERVENTION_LOT_INTERVENTION = "Liste des lots d'interventions";

export const PATH_INTERVENTION_LOT_INTERVENTION_ANIMAL = `${PATH_INTERVENTION}/lot-intervention-animal`;
export const KEY_INTERVENTION_LOT_INTERVENTION_ANIMAL = `${KEY_INTERVENTION}/lot-intervention-animal`;
export const TITLE_INTERVENTION_LOT_INTERVENTION_ANIMAL =
  "Liste des animaux des lots d'interventions";

export const PATH_INTERVENTION_GPS = `${PATH_INTERVENTION}/intervention-gps`;
export const KEY_INTERVENTION_GPS = `${KEY_INTERVENTION}/intervention-gps`;
export const TITLE_INTERVENTION_GPS = "Liste des interventions GPS";
